<script setup lang="ts">
import { ROUTE_NAMES } from "@/router/constants";
</script>

<template>
  <div class="mx-4 my-8">
    <a-row
      class="w-full max-w-screen-lg overflow-hidden bg-white rounded-2xl"
      :wrap="false"
    >
      <a-col
        class="transition-all duration-300 subscription-left grow-0 shrink-0 basis-0 lg:basis-72"
      >
        <div class="subscription-left--content !hidden lg:!flex">
          <div class="self-center mb-6">
            <router-link :to="{ name: ROUTE_NAMES.HOME }">
              <img
                alt="san-ha"
                class="object-contain w-20 h-20"
                src="@/assets/images/san-ha-logo.png"
              />
            </router-link>
          </div>
          <h2 class="font-semibold text-white">ระบบรับสมัครออนไลน์</h2>
          <p class="text-xl leading-6 text-white">
            ผู้ดำรงตำแหน่งในองค์กรตามรัฐธรรมนูญและกฎหมาย
          </p>
          <p class="text-xl leading-6 text-white">สำนักงานเลขาธิการวุฒิสภา</p>
        </div>
      </a-col>
      <a-col flex="auto">
        <slot />
      </a-col>
    </a-row>
  </div>
</template>

<style scoped>
.subscription-left {
  background: rgb(75, 15, 15);
  background-repeat: no-repeat;
  background-size: auto 60vh;
  background-position: 50% 100%;
  /* 1.316 0.759 */
}

@media screen and (min-width: 1028px) {
  .subscription-left {
    background-image: url("@/assets/images/subscription-bg.jpg");
  }
}

.subscription-left .subscription-left--content {
  flex-direction: column;
  padding: 2.5rem 1.5rem;
  height: 100%;
  background: rgb(75, 15, 15);
  background: linear-gradient(
    180deg,
    rgba(75, 15, 15, 1) 40%,
    rgba(75, 15, 15, 0.1) 100%
  );
  color: white;
}
</style>
